import moment from "moment";
import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";

const TrendLine = ({ data }) => {
	const timelineLabels = useMemo(() => {
		let startX = data.startX;
		let endX = data.endX;
		let groupByPeriod = data.groupByPeriod;
		let labels = [];
		while (startX < endX) {
			labels.push(moment(startX).format("HH:mm"));
			startX += groupByPeriod;
		}
		return labels;
	}, [data]);

	const lineChartData = (chartData) => {
		return {
			labels: timelineLabels,
			datasets: [
				{
					data: chartData.values,
					borderWidth: 1,
					lineTension: 0,
					elements: { point: { radius: 1 } },
				},
			],
		};
	};

	return (
		<Line
			data={lineChartData(data)}
			options={{
				backgroundColor: "orange",
				borderColor: "black",
				color: "green",
				responsive: true,
				maintainAspectRatio: false,
				plugins: {
					legend: {
						display: false,
					},
				},
			}}
		/>
	);
};

export default TrendLine;
